import styled from 'styled-components'

import ShowMoreText from '../../../components/ShowMoreText'
import MediaWrapper from '../../../components/cards/shared/MediaWrapper'
import ImageOrSlider from '../../../components/cards/shared/ImageOrSlider'
import HeartOnIcon from '../../../components/icons/BucketlistHeartOn'
import HeartOffIcon from '../../../components/icons/BucketlistHeartOff'

import { BucketListButton } from '../../../components/cards/shared/styled'
import { titleCase } from '../../../components/utils/stringUtils'

export const AdventureCardWrapper = styled.div<{ embedded?: boolean }>`
  height: 100%;
  font-size: 16px;
  font-weight: 300;
  font-family: 'GT Walsheim Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif !important;

  line-height: 1.375;

  color: #999;
  background-color: white;

  border: 1px solid #d1d1d1;
  border-radius: 6px;

  overflow: hidden;
  white-space: pre-wrap;

  ${({ embedded }) =>
    embedded &&
    `
    border: none;
  `}
`

const Content = styled.div`
  padding: 24px 16px;
`

export const Title = styled.h3`
  color: #333;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 8px;

  font-weight: 500;

  .icon {
    font-size: 24px;
    line-height: 1;
    display: inline-block;
    vertical-align: middle;
    margin-right: 8px;
  }
`

const IconWrapper = styled.div`
  position: relative;
  height: 0;
  padding-top: 72.222%;
  width: 100%;
  background-color: ${({ theme }) => theme.brand.sand};

  .icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    color: #333;
    font-size: 36px;
  }
`

type AdventureCardProps = GQL_ListingNearbyAdventureFragment & {
  embedded?: boolean
  isInEscape?: boolean
  onSelectEscapeClick?: () => any
  storyteller?: GQL_ListingNearbyAdventure_StoryAdventure_Fragment['storyteller']
}

export default ({
  adventureType,
  title,
  description,
  photos,
  storyteller,
  embedded,
  onSelectEscapeClick,
  isInEscape,
  url,
  __typename,
}: AdventureCardProps) => {
  return (
    <AdventureCardWrapper embedded={embedded}>
      {photos?.length > 0 ? (
        <MediaWrapper rounded={false}>
          <ImageOrSlider title={title} photos={photos} />
        </MediaWrapper>
      ) : (
        <IconWrapper>
          <div className={`icon icon-${adventureType?.slug}`} />
        </IconWrapper>
      )}
      <Content>
        <Title>
          {__typename === 'StoryAdventure' ? (
            <a href={url}>{titleCase(title)}</a>
          ) : (
            titleCase(title)
          )}
        </Title>
        <ShowMoreText lines={storyteller ? 3 : 4} inline>
          {description}
        </ShowMoreText>
      </Content>

      {onSelectEscapeClick && (
        <BucketListButton
          onClick={(e) => {
            e.preventDefault()
            onSelectEscapeClick()
          }}
          // @ts-ignore -- not typed yet
          isActive={isInEscape}
        >
          <HeartOnIcon />
          <HeartOffIcon />
        </BucketListButton>
      )}
    </AdventureCardWrapper>
  )
}

export const AdventureCardLoading = () => {
  return (
    <AdventureCardWrapper>
      <MediaWrapper rounded={false} />
      <Content style={{ height: '140px' }} />
    </AdventureCardWrapper>
  )
}
